<!--
  -  Copyright (c) Qwoach LLC 2020. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 27/9/2020
  -->

<template>
	<TagsView
		ref="tagsView"
        :view-only="viewOnly"
		:tagSuggestionsProvider="tagSuggestionsProvider"
		@change="onTagsUpdated"
		@updateSuggestion="onUpdateSuggestion"
		@removeSuggestion="onRemoveSuggestion"
		v-model="valueData"
		v-bind="$attrs"
	/>
</template>
<script>
	import TagsView from "@/core/components/Tags/TagsView.vue";
	import BaseVModelView from "@/core/components/BaseVModelView"

    export default {
        name: "SuggestionsTagsView",
		extends: BaseVModelView,

		components: {
        	TagsView
		},
		props:{
			shouldSaveNewTags: {type: Boolean, default: true},
			viewOnly: Boolean,
		},
		data: () => ({
			tagsContainerItem: null
		}),
		methods:{
        	reset(){
				this.tagsContainerItem = null
				this.getTagsContainerItem()
			},

			async onUpdateSuggestion(tag){
				if(this.analyticsProps){
					this.$analyticManager.trackEvent("Tag updated", {tags_count: this.valueData.length, ...this.analyticsPropsMethod()})
				}

				console.log("onUpdateSuggestion: tag = ", tag)
				this.tagsContainerItem.updateTag(tag)
				return this.notifyTagsChanged()
			},

        	async onRemoveSuggestion(tag){
				if(this.analyticsProps){
					this.$analyticManager.trackEvent("Tag removed", {tags_count: this.valueData.length, ...this.analyticsPropsMethod()})
				}
				console.log("onDeleteTagClicked: tag = ", tag)
				this.tagsContainerItem.removeTag(tag)
				return this.notifyTagsChanged()
			},

			async notifyTagsChanged(){
				this.$refs.tagsView.refreshSuggestionTags()
				return await this.dataManager.setTagsContainer(this.tagsContainerItem)
			},

			tagSuggestionsProvider(query){
				return this.getTagsContainerItem()
					.then(tagsContainerItem => tagsContainerItem.filter(query))
			},
			async onTagsUpdated(tagsArray){
        		if(this.analyticsProps){
					this.$analyticManager.trackEvent("Tags changed", {tags_count: tagsArray.length, ...this.analyticsPropsMethod()})
				}

				this.notifyValueChanged()
				if(this.shouldSaveNewTags) {
					let tagsContainerItem = await this.getTagsContainerItem()
					tagsContainerItem.addNewTags(tagsArray)
					return this.dataManager.setTagsContainer(tagsContainerItem)
				}
			},

			getTagsContainerItem(){
				let res = Promise.resolve(this.tagsContainerItem)

				if(!this.tagsContainerItem){
					res = this.dataManager.getTagsContainerItem()
					.then(tagsContainerItem => {
						this.tagsContainerItem = tagsContainerItem
						return this.tagsContainerItem
					})
				}
				return res
			},

			closeSuggestions() {
				this.$refs.tagsView.closeSuggestions()
			}
		}
    }
</script>

<style>

</style>
